<template>
  <Box v-if="activeBox" :aspect="aspect" :use-height="useHeight">
    <div v-if="active" class="z-0 w-full h-full">
      <div class="striped" v-bind="$attrs">
        <slot />
      </div>
    </div>
    <slot v-else />
  </Box>
  <slot v-else />
</template>

<script lang="ts" setup>
import Box from '@components/utils/Box.vue';

interface Props {
  active?: boolean;
  activeBox?: boolean;
  backgroundColor?: string;
  borderColor?: string;
  borderRadius?: string;
  aspect?: number;
  useHeight?: boolean;
}

withDefaults(defineProps<Props>(), {
  active: true,
  activeBox: true,
  color: 'var(--color-red-10)',
  borderRadius: '0px',
  backgroundColor: 'var(--color-background-light-100)',
});
</script>

<style lang="scss" scoped>
.box-content,
:deep(.box-content) {
  z-index: 0;
}

.striped {
  @apply relative h-full text-center;

  --stripe-box-border-width: 2px;
  --stripe-box-border-radius: v-bind("borderRadius");
  --stripe-box-border-color: v-bind("borderColor");
  --stripe-box-bg-color: v-bind("backgroundColor");

  position: relative;
  border: var(--stripe-box-border-width) solid transparent;
  border-radius: var(--stripe-box-border-radius);
  background-clip: padding-box;
  background-color: var(--stripe-box-bg-color);

  &::before {
    content: "";
    position: absolute;
    top: calc(var(--stripe-box-border-width) * -1); /* or without variables: 'top: -1px;' */
    right: calc(var(--stripe-box-border-width) * -1);
    bottom: calc(var(--stripe-box-border-width) * -1);
    left: calc(var(--stripe-box-border-width) * -1);
    z-index: -1;
    transition: background-color var(--speed-slow) ease;
    background-image: repeating-linear-gradient(
      135deg,
      transparent 0 10px,
      var(--stripe-box-bg-color) 8px 16px
    );
    border-radius: var(--stripe-box-border-radius);
    background-color: var(--stripe-box-border-color);
  }
}
</style>
